import { useEffect, useState } from 'react';
import { validateEmail } from '../utils/validate-email';

export const useValidateEmail = () => {
  const [isEmailValid, setIsEmailValid] = useState(true);
  const [email, setEmail] = useState('');

  useEffect(() => {
    const timer = setTimeout(() => {
      if (email) {
        setIsEmailValid(validateEmail(email));
      }
    }, 300);

    return () => {
      clearTimeout(timer);
      setIsEmailValid(true);
    };
  }, [email]);

  return {
    isEmailValid,
    setEmail,
    email,
  };
};
